import {Service} from '../../utils/Service';

export default{
  queryProvince(data) {
      return Service({
        url: 'operationApi/busCityapi/queryProvince',
        data,
        method: 'POST' ,
      })
  },
  queryCity(data) {
    return Service({
      url: 'operationApi/busCityapi/queryCity',
      data,
      method: 'POST' ,
    })
  },
  queryCounty(data) {
    return Service({
      url: 'operationApi/busCityapi/queryCounty',
      data,
      method: 'POST' ,
    })
  },
} 


// WEBPACK FOOTER //
// ./src/api/cityManage/city.js